// extracted by mini-css-extract-plugin
module.exports = {"UserTokens":"UserTokens_UserTokens__1AEpy","UserTokenList":"UserTokens_UserTokenList__2lYZn","UserTokensTitle":"UserTokens_UserTokensTitle__3MMLy"};